import type { FC, SVGProps } from 'react';

const DataflowIcon: FC<SVGProps<SVGSVGElement>> = ({ ...props }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.3333 13.5H11.2C10.0799 13.5 9.51984 13.5 9.09202 13.282C8.71569 13.0903 8.40973 12.7843 8.21799 12.408C8 11.9802 8 11.4201 8 10.3L8 6.03333C8 4.91323 8 4.35318 8.21799 3.92535C8.40973 3.54903 8.71569 3.24307 9.09202 3.05132C9.51984 2.83333 10.0799 2.83333 11.2 2.83333H11.3333M11.3333 13.5C11.3333 14.2364 11.9303 14.8333 12.6667 14.8333C13.403 14.8333 14 14.2364 14 13.5C14 12.7636 13.403 12.1667 12.6667 12.1667C11.9303 12.1667 11.3333 12.7636 11.3333 13.5ZM11.3333 2.83333C11.3333 3.56971 11.9303 4.16667 12.6667 4.16667C13.403 4.16667 14 3.56971 14 2.83333C14 2.09695 13.403 1.5 12.6667 1.5C11.9303 1.5 11.3333 2.09695 11.3333 2.83333ZM4.66667 8.16667L11.3333 8.16667M4.66667 8.16667C4.66667 8.90305 4.06971 9.5 3.33333 9.5C2.59695 9.5 2 8.90305 2 8.16667C2 7.43029 2.59695 6.83333 3.33333 6.83333C4.06971 6.83333 4.66667 7.43029 4.66667 8.16667ZM11.3333 8.16667C11.3333 8.90305 11.9303 9.5 12.6667 9.5C13.403 9.5 14 8.90305 14 8.16667C14 7.43029 13.403 6.83333 12.6667 6.83333C11.9303 6.83333 11.3333 7.43029 11.3333 8.16667Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default DataflowIcon;
